// React
import React from 'react';
import {useState, useEffect} from 'react';

// MUI
import Box from '@mui/material/Box';

// others
import { format, parseISO } from 'date-fns';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import useInterval from 'use-interval';
import { useAuth } from 'react-oidc-context';

import * as fbproto from './messages_pb.js';
import './App.css';
import { useFetch } from './hooks/useFetch.jsx';
// let proto = {fbproto: fbproto}; // not sure why my IDE can only detect/autocomplete 'proto.fbproto' correctly and not 'fbproto', so this is a workaround

export default function Dashboard(props) {
    const [devices, setDevices] = useState({
    });
    const fetchWrapper = useFetch();
    const auth = useAuth();

    useInterval(
        () => tick30s(),
        30000
    );
        
    useEffect(() => {
        // TODO: pull up one level, so devices are shared between Dashboard and Devices pages. do loading UI. either fetch() into parent state, or use react-router's loader/useLoaderData/useRouteLoaderData. how to chain calls between parent & child, use useEffect on parent state?
        var lclDevices = null;  // HACK: still needed?
        const userIdObj = {userId: auth.user.profile.sub};
        console.log("userIdObj = " + JSON.stringify(userIdObj));
        fetchWrapper.post(`https://api.${process.env.REACT_APP_DOMAIN}/devices/userid`, userIdObj)
            .then(response => {
                return response.json();
            })
            .then(responseObj => {
                // sample response: {"devices":[{"id":2,"controllerId":4,"deviceType":2,"deviceName":"some EC probe","deviceAssemblyName":"EC probe"}, ...]}
                console.log("get devices body = " + JSON.stringify(responseObj));
                var myDevices = {};
                for (const device of responseObj.devices) {
                    let displayName = device.deviceAssemblyName;
                    if (device.deviceName !== null && device.deviceName !== undefined && device.deviceName !== "" && device.deviceName !== device.deviceAssemblyName) {
                        displayName = displayName + ", " + device.deviceName;
                    }
                    var newDevice = {
                        deviceId: device.id,
                        deviceType: device.deviceType,
                        deviceName: device.deviceName,
                        deviceAssemblyName: device.deviceAssemblyName,
                        displayName: displayName,
                        chartData: []
                    };
                    if ((device.deviceType >= fbproto.DeviceType.DT_PH && device.deviceType <= fbproto.DeviceType.DT_CO2)
                        || device.deviceType === fbproto.DeviceType.DT_POWER || device.deviceType === fbproto.DeviceType.DT_MOISTURE) {
                        myDevices[""+device.id] = newDevice;
                    }
                }
                setDevices(myDevices);
                lclDevices = myDevices;
            })
            .then(() => {
                queryAndUpdateChartData(lclDevices);
            })
            .catch(error => {
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function tick30s() {
        // update each device with fetched data
        queryAndUpdateChartData(devices);
    }
    
    function queryAndUpdateChartData(thisDevices) {
        // fetch data from server
        var deviceIds = [];
        console.log("queryAndUpdateChartData: device count = " + Object.keys(thisDevices).length);
        for (const key in thisDevices) {
            deviceIds.push(thisDevices[key].deviceId);
        }
        fetchWrapper.post(`https://api.${process.env.REACT_APP_DOMAIN}/devices/readings`, {deviceIds:deviceIds})
            .then(response => {
                return response.json();
            })
            .then(responseObj => {
                console.log("readings body = " + JSON.stringify(responseObj));
                // replace devices' chartData with fetched data from server
                // sample response: {"devices":[{"deviceId":5, "readings":[{"date":"2023-01-24T07:28:14Z","id":2,"readingType":2,"value":6.4}]}]}
                setDevices(originalDevices => {
                    var replacementDevices = structuredClone(originalDevices);
                    for (const device of responseObj.devices) {
                        var newChartData = [];
                        for (const reading of device.readings) {
                            newChartData.push({
                                date: format(parseISO(reading.date), 'HH:mm:ss'),
                                fullDate: format(parseISO(reading.date), 'dd/MM/yyyy HH:mm:ss'),
                                value: reading.value,
                            });
                        }
                        // recharts crashes if any chart has only 1 data point
                        if (newChartData.length === 1) newChartData = [];
                        var newChartDataReversed = newChartData.reverse();
                        replacementDevices[device.deviceId].chartData = newChartDataReversed;
                    }
                    return replacementDevices;
                });
            });
    }
    
    function renderCharts() {
        var tempArray = [];
        Object.keys(devices).forEach(function(key, index) {
            var device = devices[key];
            tempArray.push(
                <Box key={index+'title'} sx={{lineHeight:'1.5em', alignContent:'center', paddingY:'0.5em', borderBottom:'1px solid', borderTop:'1px solid', borderColor:'grey.300'}}>{device.displayName}</Box>
            );
            tempArray.push(
                <ResponsiveContainer key={index+'chart'} width='100%' height={300}>
                    <LineChart
                        height={300}
                        data={device.chartData}
                        margin={{top: 5, right: 50, left: 20, bottom: 5}}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip labelFormatter={(label, props) => {
                            if (props.length >= 1)
                                return props[0].payload.fullDate;
                            else
                                return "";
                        }} />
                        <Line type="monotone" dataKey="value" stroke="#8884d8" isAnimationActive={false}/>
                    </LineChart>
                </ResponsiveContainer>
            );
        });
        return tempArray;
    }
    
    return (
            <Box className="Dashboard" sx={{overflow:'overlay', display:'flex', flexDirection:'column', width:'100%', height:'100%', borderTop:'1px solid', borderColor:'grey.300' }}>
                
                {renderCharts()}
                
            </Box>
    );
}

